import React, { PureComponent, Fragment } from "react";
import Pagination from "react-js-pagination";
import Parser from "html-react-parser";
import { AJAX_REQUEST, ReadMore, iniScheduleDateTime, validScheduleTime, is_Mac, IDLE_SESSION_TIMEOUT, sentryErrorLog } from "../../Constants/AppConstants";
import $ from "jquery";
import * as RBT from "react-bootstrap";
import * as faIcon from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "react-bootstrap/Tooltip";
import { Scrollbars } from "react-custom-scrollbars";
import PaginationLeftButton from "../Common/PaginationLeftButton";
import PaginationRightButton from "../Common/PaginationRightButton";
import moment from "moment";
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import AlertWrapper from '../Common/AlertWrapper';
import AlertWrapperSuccess from '../Common/AlertWrapperSuccess';
import { toast } from 'react-toastify';
import '../../../node_modules/@fullcalendar/core/main.css';
import '../../../node_modules/@fullcalendar/timegrid/main.css';
import '../../Assets/css/fullcalendar.css';
import '../../Assets/css/react-datetime.css';
import "flatpickr/dist/themes/airbnb.css";
import Flatpickr from "react-flatpickr";
import Iframe from 'react-iframe';
import Hotkeys from "react-hot-keys";

export class ScheduleMessageArea extends PureComponent {
  calendarComponentRef = React.createRef();
  constructor(props) {
    super(props);

    this.state = {
      mounted: true,
      visibleStatus: false,
      loading: true,

      // Schedule messages objects
      showScheduleMessages: false,
      scheduleMessageLoading: false,
      scheduleMsgActivePage: 1,
      schedule_msg_info: "",
      totalScheduleMsg: 0,
      schedule_count_start: 1,
      errorScheduleMessage: null,
      successScheduleMessage: null,
      scheduleMessageList: [],
      deleteScheduleMsgModalShow: false,
      deleteScheduleId: null,
      pleaseWait: false,

      // Reschedule & edit schedule
      schedule_user_name: "",
      schedule_promo_name: "",
      schedule_contact_name: "",
      schedule_message_text: "",
      schedule_status: "",
      schedule_media_url: "",
      schedule_date: "",
      schedule_time: "",
      successScheduleMsg: "",
      errorScheduleMsg: "",
      success_alert_wrapper_show: false,

      // Reschedule message time
      ReScheduleMsgTimeModalShow: false,
      reschedule_id: "",
      set_reschedule_date: new Date(),
      set_reschedule_time: new Date(),
      reschedule_date_time: new Date(),
      reschedule_date_time_formatted: "",
      errorReScheduleMsg: "",
      scheduleMessageTimeLoading: false,
      pleaseWaitRescheduleTime: false,

      // Edit Reschedule message
      activeShortcode: "default",
      EditReScheduleMsgModalShow: false,
      edit_schedule_id: "",
      code_search: "",
      shortCodeLoading: true,
      pleaseWaitEdit: false,
      scheduleMessageEditLoading: false,
      shortCodeList: [],
      errorShortCodeMessage: "",
      successEditScheduleMsg: "",
      errorEditScheduleMsg: "",
      // for most used shortcodes
      mostUsedShortcodeLoading: true,
      mostUsedShortCodeList: [],
      errorMostUsedShortCodeMessage: "",

      // ALAN Calendar states
      startTimer: "",
      owner_name: "",
      contact_name: "",
      promo_name: "",
      events: [],
      availableTimes: [],
      ownertimezone: '',
      ownertime: '',
      calendardate: moment().format('YYYY-MM-DD'),
      acuityurl: '',
      contact_firstname: '',
      contact_lastname: '',
      contact_email: '',
      contact_phone: '',

      // Event Details
      event_date: '',
      event_time: '',
      event_id: "",
      scheduleDateRange: '',
      scheduleTimeRange: '',

      // Modal
      alanCalendarModalShow: false,
      eventDetailModalShow: false,
      reScheduleModalShow: false,
      cancelScheduleModalShow: false,

      // add schedule
      addScheduleModalShow: false,
      schedule_date_time: iniScheduleDateTime(),
      set_schedule_date: iniScheduleDateTime(),
      set_schedule_time: iniScheduleDateTime(),
      validScheduleTime: validScheduleTime(),
      owner_timezone_array: '',

      // Button Texts
      checkAvailability: 'Check Availability',

      activityMaxTime: IDLE_SESSION_TIMEOUT,
      applyScheduleMessagePauseDate: "Apply",
      pauseDay: 0,
      pauseHour: 0,
      pauseMinute: 0,
      chooseHour: false,
      chooseMinute: false,

      // Settings
      pauseScheduleMessage: false,

    };
  }

  componentDidMount() {
    this.setState({ mounted: !this.state.mounted, loading: this.props.acuityCalendarLoading });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setState({
        mounted: !this.state.mounted,
        loading: this.props.acuityCalendarLoading,
        acuityCalendarLoading: this.props.acuityCalendarLoading,
        showIframe: this.props.showIframe,
        acuityurl: this.props.acuityurl,
        owner_name: this.props.owner_name,
        showScheduleMessages: false,
        alanCalendarModalShow: false,
        shortCodeLoading: false,
        shortCodeList: this.props.shortCodeList,
        errorShortCodeMessage: this.props.errorShortCodeMessage,
        mostUsedShortcodeLoading: false,
        mostUsedShortCodeList: this.props.mostUsedShortCodeList,
        errorMostUsedShortCodeMessage: this.props.errorMostUsedShortCodeMessage,
        applyScheduleMessagePauseDate: "Apply",
        pauseDay: '0',
        pauseHour: '0',
        pauseMinute: '0',
        pauseScheduleMessage: this.props.pauseScheduleMessage,
      });
    }
  }

  loadEvents = () => {
    const user_data = {
      user_id: this.props.current_gym_owner,
      contact_id: this.props.current_contact,
    };
    AJAX_REQUEST("POST", "operator/getAlanCalendarEvent", user_data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        const calendar_data = results.response.data;
        this.setState({
          events: calendar_data.hasOwnProperty('events') ? calendar_data.events : [],
        });
      } else {
        toast.error(results.response.message, { autoClose: 3000 });
      }
    });
  }

  getScheduleMessages = (pageNumber = 1, noLoading = false) => {
    if (this.props.current_gym_owner === "") {
      this.setState({
        scheduleMsgActivePage: 1,
      });
    } else {
      this.setState({ scheduleMessageLoading: !noLoading });
      const data = {
        user_id: this.props.current_gym_owner,
        contact_id: this.props.current_contact,
      };
      AJAX_REQUEST("POST", "operator/getScheduleMessages", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const data = results.response.data;
          this.setState({
            scheduleMessageLoading: false,
            scheduleMsgActivePage: pageNumber,
            schedule_msg_info: data.schedule_msg_info,
            totalScheduleMsg: parseInt(data.total_messages),
            scheduleMessageList: data.messages,
            errorScheduleMessage: null,
            scheduleMsgStart: 0,
            scheduleMsgLimit: 8,
          });

          if ((pageNumber === 1) && (data.messages.length > 0)) {
            this.props.changeShowPauseAndSent(true);
          }
        } else {
          this.setState({
            scheduleMessageLoading: false,
            errorScheduleMessage: results.response.message,
          });
        }
      }
      );
    }
  };

  paginationScheduleMessages = (pageNumber) => {
    const start = parseInt((pageNumber - 1) * 9);
    const limit = parseInt(start + 8);
    const schedule_msg_info =
      pageNumber * 9 < this.state.totalScheduleMsg
        ? pageNumber * 9
        : this.state.totalScheduleMsg;
    this.setState({
      scheduleMsgStart: start,
      scheduleMsgLimit: limit,
      schedule_msg_info:
        schedule_msg_info + " of " + parseInt(this.state.totalScheduleMsg),
      schedule_count_start: start + 1,
      scheduleMsgActivePage: pageNumber,
    });
  };

  deleteScheduleMsgModal = (
    visibleStatus,
    schedule_id = null,
    isDelete = "no"
  ) => {
    this.setState({
      deleteScheduleMsgModalShow: visibleStatus,
      deleteScheduleId: schedule_id,
      pleaseWait: false
    });

    if (isDelete === "yes" && schedule_id !== null) {
      this.setState({ pleaseWait: true });
      const data = { schedule_id: schedule_id };

      AJAX_REQUEST("POST", "operator/deleteScheduleMessage", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const scheduleMessageList = this.state.scheduleMessageList;

          this.setState({
            scheduleMessageList: scheduleMessageList.filter(
              (el) => parseInt(el.schedule_id) !== parseInt(schedule_id)
            ),
            pleaseWait: false,
            deleteScheduleId: null,
            deleteScheduleMsgModalShow: false,
            successScheduleMessage: null,
            errorScheduleMessage: null,
          });
          toast.success(results.response.message, { autoClose: 3000 });
        } else {
          this.setState({
            pleaseWait: false,
          });
          toast.error(results.response.message, { autoClose: 3000 });
        }
      }
      );
    }
  };

  alanCalendarModal = (visibleStatus) => {
    let modalShown = this.state.alanCalendarModalShow;
    if (visibleStatus) {

      this.setState({
        alanCalendarModalShow: visibleStatus,
        showIframe: false,
        showScheduleMessages: false,
      })

      const user_data = {
        user_id: this.props.current_gym_owner,
        contact_id: this.props.current_contact,
      };
      AJAX_REQUEST("POST", "operator/getAlanCalendarEvent", user_data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const calendar_data = results.response.data;
          this.setState({
            events: calendar_data.hasOwnProperty('events') ? calendar_data.events : [],
            showIframe: !visibleStatus,
            showScheduleMessages: false,
          });
          $(".full-calendar .fc-prev-button").click();
          $(".full-calendar .fc-today-button").click();
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
        }
      });

      setTimeout(() => {
        if (!modalShown) {
          this.getTimezone(true);
        }
      }, 1000);
    }
    else {
      this.setState({
        alanCalendarModalShow: false,
        ownertime: this.startTimer(false, 0),
      });
    }
  }

  getTimezone = (startTimer = false) => {
    const data = {
      user_id: parseInt(this.props.current_gym_owner),
      contact_id: parseInt(this.props.current_contact),
    };
    AJAX_REQUEST("POST", "operator/getTimezone", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        this.setState({
          owner_timezone_array: results.response.data.owner_timezone_array,
          ownertimezone: results.response.data.owner_active_timezone
        });
        if (startTimer) {
          setTimeout(() => {
            this.setState({
              ownertime: this.startTimer(true, this.state.owner_timezone_array.date),
            })
          }, 1000);
        }
      } else {
        toast.error(results.response.message, { autoClose: 3000 });
      }
    });
  }

  timeOut = (timedata) => {
    setTimeout(function () {
      this.setState({
        success_alert_wrapper_show: false,
      });
    }.bind(this), timedata);
  }

  eventDetailModal = (visibleStatus, info) => {
    info.jsEvent.preventDefault();
    this.setState({
      contact_name: 'Loading..',
      event_date: 'Loading..',
      event_time: 'Loading..',
      schedule_id: 'Loading..',
    });
    if (info.event.rendering !== "background") {
      const event_data = {
        user_id: this.props.current_gym_owner,
        event_id: info.event.id,
      };
      AJAX_REQUEST("POST", "operator/getAlanCalendarEventDetails", event_data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const event_details = results.response.data;
          this.setState({
            eventDetailModalShow: visibleStatus,
            contact_name: event_details.appointment ? event_details.appointment.contact_name : '',
            event_date: event_details.appointment ? event_details.appointment.schedule_date : '',
            event_time: event_details.appointment ? event_details.appointment.schedule_time : '',
            schedule_id: event_details.id ? event_details.id : '',
          });
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
        }
      });
    }
  };

  eventDetailModalClose = (visibleStatus) => {
    this.setState({
      eventDetailModalShow: visibleStatus,
    });
  }

  getCalendarDate = (view) => {
    let calendar = this.calendarComponentRef;
    if (calendar) {
      let fcdate = moment(view.view.activeStart).format("YYYY-MM-DD");
      setTimeout(
        function () {
          this.setState({
            calendardate: fcdate,
          });
        }
          .bind(this),
        1000
      );
    }
  };

  checkAvailability = (event) => {
    event.preventDefault();
    const date_data = {
      user_id: this.props.current_gym_owner,
      contact_id: this.props.current_contact,
      date_check: this.state.calendardate,
    };
    this.setState({
      checkAvailability: 'Checking..',
    });
    AJAX_REQUEST("POST", "operator/dateCheckAvailability", date_data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        let events_old = this.state.events;
        let availabletimes = results.response.data.hasOwnProperty('events') ? results.response.data.events : [];
        let all_events = events_old.concat(availabletimes);
        this.setState({
          events: all_events,
          checkAvailability: 'Check Availability',
        });
      } else {
        this.setState({
          errorScheduleMessage: results.response.message,
          checkAvailability: 'Check Availability',
        });
      }
    }
    );
  };

  iframeAcuity = (isVisible) => {
    if (isVisible) {
      this.setState({
        showIframe: isVisible,
        showScheduleMessages: !isVisible,
      })
      if (!this.state.acuityurl) {
        toast.error('Acuity Calendar Not Available!', { autoClose: 3000 });
      }
      this.alanCalendarModal(!isVisible);
    }
  }

  startTimer = (visibleStatus, datetime) => {
    let startTimestamp = moment(datetime);
    clearInterval(this.state.startTimer);
    setTimeout(() => {
      let sec = 0;
      let startclock;
      if (!visibleStatus) {
        clearInterval(this.state.startTimer);
        this.setState({
          ownertime: "Loading..",
        });
      } else {
        if (sec === 0) {
          this.setState({
            ownertime: "Loading..",
          });
        }
        startclock = setInterval(() => {
          sec++;
          startTimestamp.add(sec, "second");
          this.setState({
            ownertime: startTimestamp
              ? startTimestamp.format("MMMM DD, YYYY h:mm:ss A")
              : "Loading..",
          });
          sec = 0;
        }, 1000);
        this.setState({
          startTimer: startclock,
        });
      }
    }, 100);
  };

  setScheduleDate = (dateTime, getType = "date") => {
    let set_reschedule_date = this.state.set_reschedule_date;
    let set_reschedule_time = this.state.set_reschedule_time;

    if (getType === "date") {
      set_reschedule_date = dateTime;
    } else {
      set_reschedule_time = dateTime;
    }

    let reschedule_date_time =
      moment(set_reschedule_date).format("YYYY-MM-DD") + " " + moment(set_reschedule_time).format("H:mm:ss");

    this.setState({
      set_reschedule_date,
      set_reschedule_time,
      reschedule_date_time,
    });
  };

  showScheduleMessages = () => {
    this.setState({
      showScheduleMessages: true,
      showIframe: false,
      alanCalendarModalShow: false,
    });
    this.alanCalendarModal(false);
    this.getScheduleMessages();
    this.getTimezone();
  }

  getScheduleMessage = (schedule_id = null) => {
    this.setState({
      scheduleMessageTimeLoading: true,
      scheduleMessageEditLoading: true,
      successScheduleMsg: "",
      errorScheduleMsg: ""
    });

    if (schedule_id !== null || schedule_id !== '') {
      const data = {
        schedule_id: schedule_id
      };

      AJAX_REQUEST("POST", "operator/getScheduleMessage", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const data = results.response.data.message;
          this.setState({
            schedule_user_name: data.user_name,
            schedule_contact_name: data.contact_name,
            schedule_promo_name: data.promo_name,
            schedule_message_text: data.message_text,
            schedule_status: data.status,
            schedule_media_url: data.media_url,
            schedule_date: data.schedule_date,
            schedule_time: data.schedule_time.replace(" pm", ""),
            scheduleMessageTimeLoading: false,
            scheduleMessageEditLoading: false,
            errorScheduleMsg: null,
          });
          console.log(data.schedule_time.replace(" pm", ""))
          document.getElementById("edit_schedule_message").value = data.message_text;
        } else {
          this.setState({
            scheduleMessageTimeLoading: false,
            scheduleMessageEditLoading: false,
            errorScheduleMsg: results.response.message,
          });
        }
      }
      );

    }
  }

  reScheduleMessageTimeModal = (visibleStatus, isUpdate = "no", schedule_id = null,) => {
    this.setState({
      ReScheduleMsgTimeModalShow: visibleStatus,
      errorReScheduleMsgTime: null,
      reschedule_id: schedule_id,
    });
    if (visibleStatus === true && isUpdate === 'no') {
      this.getScheduleMessage(schedule_id);
    }

    if (isUpdate === "yes" && this.state.reschedule_id !== "") {
      this.setState({ pleaseWaitRescheduleTime: true });
      const data = {
        schedule_id: parseInt(this.state.reschedule_id),
        schedule_time: moment(this.state.reschedule_date_time ? this.state.reschedule_date_time : '').format("YYYY-MM-DD H:mm:ss"),
      };

      AJAX_REQUEST("POST", "operator/updateScheduleMessage", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          toast.success(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWaitRescheduleTime: false,
            reschedule_date_time: "",
            ReScheduleMsgTimeModalShow: false,
          });
          this.getScheduleMessages(this.state.scheduleMsgActivePage, true);
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWaitRescheduleTime: false,
          });
        }
      });
    }
    if (visibleStatus) {
      this.setState({
        chooseHour: false,
        chooseMinute: false
      }, () => {
        setTimeout(() => {
          let hourexists = document.querySelector(".numInput.flatpickr-hour");
          if (hourexists) {
            document.querySelector(".numInput.flatpickr-hour").addEventListener("click", function () {
              this.chooseHour(true);
            }.bind(this));
          }
          let minuteexists = document.querySelector(".numInput.flatpickr-minute");
          if (minuteexists) {
            document.querySelector(".numInput.flatpickr-minute").addEventListener("click", function () {
              this.chooseMinute(true);
            }.bind(this));
          }
        }, 1500);
      });
    }
  }

  setScheduleMessage = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  editReScheduleMessageModal = (visibleStatus, isUpdate = "no", schedule_id = null,) => {
    this.setState({
      EditReScheduleMsgModalShow: visibleStatus,
      edit_schedule_id: schedule_id,
      errorEditScheduleMsg: "",
      successEditScheduleMsg: "",
    });
    if (visibleStatus === true && isUpdate === 'no') {

      this.getScheduleMessage(this.state.edit_schedule_id ? this.state.edit_schedule_id : schedule_id);
    }

    this.getShortCode();

    if (isUpdate === "yes" && this.state.edit_schedule_id !== "") {
      this.setState({ pleaseWaitEditSchedule: true });
      const txtarea_message_text = document.getElementById("edit_schedule_message");
      const data = {
        schedule_id: parseInt(this.state.edit_schedule_id),
        message_text: txtarea_message_text.value
      };

      AJAX_REQUEST("POST", "operator/updateScheduleMessage", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const data = results.response.data.message;
          toast.success(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWaitEditSchedule: false,
            edit_schedule_id: data.schedule_id,
            EditReScheduleMsgModalShow: false,
          });
          this.getScheduleMessages(this.state.scheduleMsgActivePage, true);
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWaitEditSchedule: false,
          });
        }
      });

    }
  }

  codeSearch = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  addShortcode = (e, addShortcode) => {
    e.preventDefault();
    if (addShortcode.field_type) {
      if (addShortcode.field_type === "text") {
        let field_datas = {
          'user_id': this.props.current_gym_owner,
          'contact_id': this.props.current_contact,
          'field_name': addShortcode.field_name,
          'field_id': addShortcode.id,
        };
        AJAX_REQUEST("POST", "operator/getCustomFieldText", field_datas).then((results) => {

          // Sentry Log create
          sentryErrorLog(results);

          if (parseInt(results.response.code) === 1000) {
            let field_data = results.response.data;
            if (field_data.text) {
              this.insertAtCaret(
                "edit_schedule_message",
                field_data.text
              );
            }
            else {
              toast.error("No Text Set Yet!", { autoClose: 3000 })
            }
          } else {
            toast.error(results.response.message, { autoClose: 3000 })
          }
        });
      } else {
        this.insertAtCaret(
          "edit_schedule_message",
          "[" + addShortcode.field_name + "]"
        );
      }
    }
  };

  insertAtCaret = (areaId, text) => {
    var txtarea = document.getElementById(areaId);
    if (!txtarea) {
      return;
    }

    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br =
      txtarea.selectionStart || txtarea.selectionStart === "0"
        ? "ff"
        : document.selection
          ? "ie"
          : false;
    if (br === "ie") {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart("character", -txtarea.value.length);
      strPos = range.text.length;
    } else if (br === "ff") {
      strPos = txtarea.selectionStart;
    }

    var front = txtarea.value.substring(0, strPos);
    var back = txtarea.value.substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br === "ie") {
      txtarea.focus();
      var ieRange = document.selection.createRange();
      ieRange.moveStart("character", -txtarea.value.length);
      ieRange.moveStart("character", strPos);
      ieRange.moveEnd("character", 0);
      ieRange.select();
    } else if (br === "ff") {
      txtarea.selectionStart = strPos;
      txtarea.selectionEnd = strPos;
      txtarea.focus();
    }

    txtarea.scrollTop = scrollPos;
  };

  onKeyDown(keyName, e, handle) {
    e.preventDefault();
    document.getElementById('sma' + handle.shortcut).click();
  }

  handleShortcode = (activeCode = 'default') => {
    this.setState({
      activeShortcode: activeCode
    });
  }

  // editReScheduleMessageModal
  editReScheduleMessageModal = (visibleStatus, isUpdate = "no", schedule_id = null,) => {
    this.setState({
      EditReScheduleMsgModalShow: visibleStatus,
      edit_schedule_id: schedule_id,
      errorEditScheduleMsg: "",
      successEditScheduleMsg: "",
    });
    if (visibleStatus === true && isUpdate === 'no') {

      this.getScheduleMessage(this.state.edit_schedule_id ? this.state.edit_schedule_id : schedule_id);
    }

    if (isUpdate === "yes" && this.state.edit_schedule_id !== "") {
      this.setState({ pleaseWaitEditSchedule: true });
      const txtarea_message_text = document.getElementById("edit_schedule_message");
      const data = {
        schedule_id: parseInt(this.state.edit_schedule_id),
        message_text: txtarea_message_text.value
      };

      AJAX_REQUEST("POST", "operator/updateScheduleMessage", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {

          toast.success(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWaitEditSchedule: false,
            reschedule_date_time: "",
            EditReScheduleMsgModalShow: false,
          });
          this.getScheduleMessages(this.state.scheduleMsgActivePage, true);
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWaitEditSchedule: false,
          });
        }
      });

    }
  }

  reScheduleModal = (visibleStatus, isConfirmed = "no") => {
    this.setState({
      errorReScheduleMsg: null,
      pleaseWait: false,
      chooseHour: false,
      chooseMinute: false
    });

    const data = {
      user_id: parseInt(this.props.current_gym_owner),
      event_id: parseInt(this.state.schedule_id),
    };

    AJAX_REQUEST("POST", "operator/getAlanCalendarEventDetails", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        this.setState({
          reScheduleModalShow: visibleStatus,
          scheduleDateRange: results.response.data.appointment.schedule_date,
          scheduleTimeRange: results.response.data.appointment.schedule_time,
        });
      } else {
        toast.error(results.response.message, { autoClose: 3000 });
      }
    });

    if (isConfirmed === "yes") {
      this.setState({ pleaseWait: true });
      const data = {
        user_id: parseInt(this.props.current_gym_owner),
        contact_id: parseInt(this.props.current_contact),
        schedule_id: parseInt(this.state.schedule_id),
        datetime: moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD H:mm:ss"),
        app_version: 2,
      };

      AJAX_REQUEST("POST", "operator/editSchedule", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          toast.success(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWait: false,
            reScheduleModalShow: false,
            eventDetailModalShow: false,
          });
          this.iframeAcuity(true);
          this.loadEvents();
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWait: false,
          });
        }
      });
    }
    if (visibleStatus && !(this.state.pleaseWait)) {
      this.setState({
        chooseHour: false,
        chooseMinute: false
      }, () => {
        setTimeout(() => {
          let hourexists = document.querySelector(".numInput.flatpickr-hour");
          if (hourexists) {
            document.querySelector(".numInput.flatpickr-hour").addEventListener("click", function () {
              this.chooseHour(true);
            }.bind(this));
          }
          let minuteexists = document.querySelector(".numInput.flatpickr-minute");
          if (minuteexists) {
            document.querySelector(".numInput.flatpickr-minute").addEventListener("click", function () {
              this.chooseMinute(true);
            }.bind(this));
          }
        }, 1500);
      });

    }
  };

  cancelScheduleModal = (visibleStatus, isConfirmed = "no") => {
    this.setState({
      cancelScheduleModalShow: visibleStatus,
      errorCancelScheduleMsg: null,
      pleaseWait: false
    });

    if (isConfirmed === "yes") {
      this.setState({ pleaseWait: true });
      const data = {
        user_id: parseInt(this.props.current_gym_owner),
        event_id: parseInt(this.state.schedule_id),
      };

      AJAX_REQUEST("POST", "operator/cancelAppointment", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          toast.success(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWait: false,
            cancelScheduleModalShow: false,
            eventDetailModalShow: false,
            is_scheduled: "no",
            schedule_id: "",
          });
          this.iframeAcuity(true);
          this.loadEvents();
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.setState({
            pleaseWait: false,
          });
        }
      });
    }
  };

  detectIframeMouseOver = (e) => {
    // console.log(e)
  }


  applyScheduleMessagePauseDate = () => {
    this.setState({
      applyScheduleMessagePauseDate: "Please Wait.."
    })
    let data = {
      user_id: parseInt(this.props.current_gym_owner),
      contact_id: parseInt(this.props.current_contact),
      pauseDay: this.state.pauseDay ? this.state.pauseDay : 0,
      pauseHour: this.state.pauseHour ? this.state.pauseHour : 0,
      pauseMinute: this.state.pauseMinute ? this.state.pauseMinute : 0
    };
    AJAX_REQUEST("POST", "operator/pauseScheduleMessages", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        toast.success(results.response.message, { autoClose: 3000 });
        this.setState({
          applyScheduleMessagePauseDate: "Apply",
        });
        this.getScheduleMessages(this.state.scheduleMsgActivePage, true);
      } else {
        toast.error(results.response.message, { autoClose: 3000 });
        this.setState({
          applyScheduleMessagePauseDate: "Apply",
        });
      }
    });
  }

  changePause = (e) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/\D/, '')
    });
  }

  chooseHour = (status) => {
    this.setState({
      chooseHour: status
    });
    if (status) {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.add("d-none");
    }
    else {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.remove("d-none");
    }
  }

  chooseMinute = (status) => {
    this.setState({
      chooseMinute: status
    });
    if (status) {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.add("d-none");
    }
    else {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.remove("d-none");
    }
  }

  selectHour = (e, hour) => {
    e.preventDefault();
    let timed = moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD HH:mm:ss");
    let dateStr = moment(timed).format("YYYY-MM-DD"),
      timeStr = moment(timed).format("HH:mm:ss"),
      date = moment(dateStr),
      time = moment(timeStr, 'HH:mm:ss'),
      ampm = moment(timed).format("A");
    let hourset = hour;
    if (ampm === "PM") {
      hourset = parseInt(hour) + 12;
    }
    date.set({
      hour: hourset,
      minute: time.get('minute'),
      second: 0
    });

    let newdate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.setScheduleDateTime(newdate);
    this.chooseHour(false);
    document.querySelector(".numInput.flatpickr-hour").value = hour;
    setTimeout((e) => {
      var element = document.querySelector('.flatpickr-am-pm');
      this.simulateMouseClick(element);
      this.simulateMouseClick(element);
    }, 200);
  }

  selectMinute = (e, minute) => {
    e.preventDefault();
    let timed = moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD HH:mm:ss");
    let dateStr = moment(timed).format("YYYY-MM-DD"),
      timeStr = moment(timed).format("HH:mm:ss"),
      date = moment(dateStr),
      time = moment(timeStr, 'HH:mm:ss');

    date.set({
      hour: time.get('hour'),
      minute: minute,
      second: 0
    });

    let newdate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.setScheduleDateTime(newdate);
    this.chooseMinute(false);
    document.querySelector(".numInput.flatpickr-minute").value = minute;
    setTimeout((e) => {
      var element = document.querySelector('.flatpickr-am-pm');
      this.simulateMouseClick(element);
      this.simulateMouseClick(element);
    }, 200);
  }

  simulateMouseClick = (targetNode) => {
    function triggerMouseEvent(targetNode, eventType) {
      var clickEvent = document.createEvent('MouseEvents');
      clickEvent.initEvent(eventType, true, true);
      targetNode.dispatchEvent(clickEvent);
    }
    ["mouseover", "mousedown", "mouseup", "click"].forEach(function (eventType) {
      triggerMouseEvent(targetNode, eventType);
    });
  }

  setScheduleDateTime = (date, type = "appointment") => {
    if (type === "message") {
      this.setState({
        set_reschedule_date: moment(date).format("YYYY-MM-DD HH:mm:ss"),
        set_reschedule_time: moment(date).format("YYYY-MM-DD HH:mm:ss"),
        reschedule_date_time: moment(date).format("YYYY-MM-DD HH:mm:ss"),
      });
    }
    else {
      this.setState({
        schedule_date_time: moment(date).format("YYYY-MM-DD HH:mm:ss")
      })
    }
  }

  typeMessage = (e) => {
    let value = document.getElementById("edit_schedule_message").value;
    let typed_shortcodes_str = [];
    typed_shortcodes_str = value.match(/\[[^\]]*]/g);
    let typed_shortcodes_arr = [];
    let shortcode_arr = [];
    let typed_shortcodes_has = [];

    if (typed_shortcodes_str) {
      if (this.state.shortCodeList) {
        this.state.shortCodeList.map(function (single_shortcode, index) {
          single_shortcode.fields.map(function (val, ind) {
            shortcode_arr.push(val.field_name);
            return true;
          });
          return true;
        });
      }
      typed_shortcodes_str.map(function (typed_single, index) {
        let each_val = typed_single.replace(/[[\]]/g, '');
        typed_shortcodes_arr[index] = each_val;
        typed_shortcodes_has[index] = shortcode_arr.includes(each_val);
        if (shortcode_arr.includes(each_val) === false) {
          toast.info(`Your typed Shortcode [${each_val}] doesn't exist in this leads shortcode list!`, { autoClose: 3000 });
          setTimeout(() => {
            let new_val = value.replace(`[${each_val}]`, '');
            document.getElementById("edit_schedule_message").value = new_val;
          }, 1000);
        }
        return true;
      });
    }

  };

  render() {

    const ismac = (is_Mac() === 'mac') ? true : false;

    let getRoundedDate = (minutes, d) => {
      let ms = 1000 * 60 * minutes; // convert minutes to ms
      let roundedDate = new Date(Math.ceil(d.getTime() / ms) * ms);
      return roundedDate;
    }

    let datetimeround = getRoundedDate(5, this.state.owner_timezone_array ? (this.state.owner_timezone_array.date ? new Date(this.state.owner_timezone_array.date) : '') : new Date());
    let date = datetimeround;
    let nowtime = this.state.owner_timezone_array ? moment(this.state.owner_timezone_array.date) : moment();
    nowtime = nowtime.format();

    return (
      this.state.loading ? (
        <div className="loading">
          <FontAwesomeIcon icon={faIcon.faSyncAlt} />
        </div>
      )
        :
        <Fragment>
          <div className="main-chat-top-header">
            <div className="header-btn-group">
              <ul>
                <li className="alan-schedulemessages">
                  <RBT.Nav.Link
                    href="#"
                    className={this.state.showScheduleMessages ? 'active' : ''}
                    onClick={() => this.showScheduleMessages(true)}
                  >
                    Schedule Messages
                  </RBT.Nav.Link>
                </li>
                {/* <li className="alan-calender">
                  <RBT.Nav.Link
                    href="#"
                    className={this.state.alanCalendarModalShow ? 'active' : ''}
                    onClick={() => this.alanCalendarModal(true)}
                  >
                    Alan Calendar <FontAwesomeIcon icon={faIcon.faCalendarAlt} />
                  </RBT.Nav.Link>
                </li> */}
                <li className="acuity-calende">
                  <RBT.Nav.Link className={this.state.showIframe ? 'active' : ''} href="#" onClick={() => this.iframeAcuity(true)}>
                    Acuity Calendar{" "}
                    {!this.state.acuityCalendarLoading ? <FontAwesomeIcon icon={faIcon.faChevronDown} /> : <FontAwesomeIcon className={'fa-spin'} icon={faIcon.faSpinner} />}
                    {" "}
                  </RBT.Nav.Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="shedule-messages-container">
            {
              this.state.showIframe ? (
                this.state.acuityurl ?
                  <div
                    onMouseMove={(e) => this.detectIframeMouseOver(e)}
                    onMouseDown={(e) => this.detectIframeMouseOver(e)}
                    onMouseOver={(e) => this.detectIframeMouseOver(e)}
                  >
                    <Iframe
                      id="acuityIframe"
                      url={this.state.acuityurl}
                      width="100%"
                      height="100%"
                      className="iframeacuity"
                    />
                  </div>
                  :
                  (
                    <div className="no-acuity-calendar">
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <button className="btn btn-primary btn-sm" onClick={() => this.iframeAcuity(true)}>Reload</button>
                        <p>Acuity Calendar Not Available!</p>
                      </div>
                    </div>
                  )
              )
                :
                ''
            }
            {
              this.state.showScheduleMessages ?
                (
                  <Fragment>
                    <div className="shedule-messages-header">
                      <div className="latest-replies-header-title">
                        {" "}
                        Schedule Messages{" "}
                      </div>
                      <div className="latest-replies-header-pagination">
                        <span> {this.state.schedule_msg_info ? this.state.schedule_count_start + ' - ' + this.state.schedule_msg_info : ''} </span>
                        <div className="schedule-message">
                          <Pagination
                            activePage={this.state.scheduleMsgActivePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalScheduleMsg}
                            pageRangeDisplayed={1}
                            onChange={(pageNumber) =>
                              this.paginationScheduleMessages(pageNumber)
                            }
                            prevPageText={<PaginationLeftButton />}
                            nextPageText={<PaginationRightButton />}
                            hideFirstLastPages={true}
                          />
                        </div>
                      </div>
                    </div>

                    <ul className="shedule-messages-list-wrapper">
                      {this.state.scheduleMessageLoading ? (
                        <div className="loading">
                          <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                        </div>
                      ) : (
                        <Fragment>
                          {this.state.scheduleMessageList.length <= 0 ? (
                            ''
                          ) : (
                            this.state.pauseScheduleMessage ?
                              <div className="col-12 p-0 pauseTo">
                                <strong>
                                  Delay message by
                                </strong>
                                <input type="text" name="pauseDay" id="pauseDay" className="pauseInput" onChange={this.changePause} value={this.state.pauseDay ? this.state.pauseDay : ''} /><span className="pauseLabel">Days</span>
                                <input type="text" name="pauseHour" id="pauseHour" className="pauseInput" onChange={this.changePause} value={this.state.pauseHour ? this.state.pauseHour : ''} /><span className="pauseLabel">Hours</span>
                                <input type="text" name="pauseMinute" id="pauseMinute" className="pauseInput" onChange={this.changePause} value={this.state.pauseMinute ? this.state.pauseMinute : ''} /><span className="pauseLabel">Minutes</span>
                                <button className="btn btn-sm applyScheduleMessagePauseDate" onClick={() => { this.applyScheduleMessagePauseDate() }}>
                                  {this.state.applyScheduleMessagePauseDate}
                                </button>
                              </div>
                              : ''
                          )
                          }
                          {this.state.scheduleMessageList.length <= 0 ? (
                            <div className="server-error-message">
                              Schedule message not found.
                            </div>
                          ) : (
                            this.state.scheduleMessageList.map(
                              function (message, key) {
                                if (
                                  this.state.scheduleMsgStart <= key &&
                                  this.state.scheduleMsgLimit >= key
                                ) {
                                  return (
                                    <Fragment key={message.schedule_id}>
                                      <li>
                                        <div className="shedule-messages-list">
                                          <div className="title">
                                            {ReadMore(message.message_text)}
                                          </div>
                                          <div className="date-time">
                                            <FontAwesomeIcon icon={faIcon.faPaperPlane} />
                                            {message.schedule_run_time}
                                          </div>
                                          <div className="over-action">
                                            <RBT.Button
                                              className="re-schedule-message-time-modal"
                                              title="Reschedule"
                                              onClick={() => this.reScheduleMessageTimeModal(true, 'no', message.schedule_id)}>
                                              <FontAwesomeIcon icon={faIcon.faHistory} />
                                            </RBT.Button>

                                            <RBT.Button
                                              className="edit-reschedule-message-modal"
                                              title="Edit Message"
                                              onClick={() => this.editReScheduleMessageModal(true, "no", message.schedule_id)}
                                            >
                                              <FontAwesomeIcon icon={faIcon.faEdit} />
                                            </RBT.Button>

                                            <RBT.Button
                                              className="delete"
                                              title="Delete Message"
                                              onClick={() =>
                                                this.deleteScheduleMsgModal(
                                                  true,
                                                  message.schedule_id
                                                )
                                              }
                                            >
                                              <FontAwesomeIcon icon={faIcon.faTrashAlt} />
                                            </RBT.Button>
                                          </div>
                                        </div>
                                      </li>
                                    </Fragment>
                                  );
                                }
                              }.bind(this)
                            )
                          )}
                        </Fragment>
                      )}
                    </ul>
                  </Fragment>
                )
                :
                ''
            }
            {
              this.state.alanCalendarModalShow ?
                (
                  <Fragment>
                    <div className='full-calendar'>
                      <FullCalendar
                        defaultView="timeGridDay"
                        plugins={[timeGridPlugin]}
                        height={"parent"}
                        // contentHeight={200}
                        customButtons={{
                          checkAvailability: {
                            text: this.state.checkAvailability,
                            click: (event) => this.checkAvailability(event),
                          },
                          ownerName: {
                            text: this.state.owner_name ? this.state.owner_name : 'Loading..',
                          },
                          timeZone: {
                            text: (this.state.ownertimezone ? this.state.ownertimezone : 'Loading...'),
                          },
                          ownertime: {
                            text: (this.state.ownertime ? this.state.ownertime : 'Loading..'),
                          },
                        }}
                        ref={this.calendarComponentRef}
                        nowIndicator={true}
                        // timeZone= {this.state.owner_timezone_array ? this.state.owner_timezone_array.timezone : ''}
                        now={nowtime}
                        displayEventTime={false}
                        // scrollTime = {nowtime}
                        header={{
                          left: "prev, next, today, ownerName, title",
                          right: "timeZone, ownertime, checkAvailability",
                        }}
                        datesRender={(view) => this.getCalendarDate(view)}
                        timeZone={this.state.ownertimezone}
                        events={this.state.events}
                        eventClick={(info) => this.eventDetailModal(true, info)}
                      />
                    </div>
                  </Fragment>
                )
                :
                ''
            }
          </div>


          {/* Start delete schedule message modal */}
          <RBT.Modal
            className="live-chat-modal"
            centered
            show={this.state.deleteScheduleMsgModalShow}
            onHide={() => this.deleteScheduleMsgModal(false)}
          >
            <RBT.Modal.Header closeButton>
              <RBT.Modal.Title>Delete Schedule Replies</RBT.Modal.Title>
            </RBT.Modal.Header>
            <RBT.Modal.Body>
              <div className="delete-content">
                <div>
                  {this.state.errorScheduleMessage ? (
                    <div className="text-center text-danger">
                      {this.state.errorScheduleMessage}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.errorScheduleMessage
                    ? ""
                    : Parser(
                      `<span>Are you sure,</span> you want to Delete this Schedule Reply?`
                    )}
                  <RBT.Button
                    disabled={this.state.pleaseWait}
                    onClick={() =>
                      this.deleteScheduleMsgModal(
                        true,
                        this.state.deleteScheduleId,
                        "yes"
                      )
                    }
                  >
                    {this.state.pleaseWait
                      ? "Deleting..."
                      : this.state.errorScheduleMessage
                        ? "Try Again"
                        : "Yes"}
                  </RBT.Button>
                </div>
              </div>
            </RBT.Modal.Body>
          </RBT.Modal>
          {/* End delete schedule message modal */}

          {/* Start reschedule modal */}
          <RBT.Modal
            className="live-chat-modal calender-and-clock-modal calender-and-clock-Reschedule only-add"
            centered
            show={this.state.reScheduleModalShow}
            onHide={() => this.reScheduleModal(false)}
          >
            <RBT.Modal.Header closeButton>
              <RBT.Modal.Title>Reschedule Appointment</RBT.Modal.Title>
            </RBT.Modal.Header>
            <RBT.Modal.Body>
              <div className="add-schedule-modal">
                {this.state.errorReScheduleMsg ? (
                  <div className="text-center text-danger">{this.state.errorReScheduleMsg}</div>
                ) : (
                  ""
                )}
                <div className="add-schedule-modal-btwn">
                  <div className="row">
                    <div className="col-6">
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faUser} /> {this.state.contact_name}
                        <span>{this.state.promo_name}</span>
                      </div>
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faBriefcase} /> {this.state.owner_name}
                      </div>
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faCalendarWeek} /> <b>TimeZone: </b> {this.state.owner_timezone_array ? this.state.owner_timezone_array.timezone : ''}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faCalendarCheck} className="text-success" />
                        {this.state.scheduleDateRange}
                      </div>
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faClock} />
                        {this.state.scheduleTimeRange}
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
                <div className="row flatpickerDiv">
                  <Flatpickr
                    data-enable-time
                    onChange={(date) => {
                      this.setScheduleDateTime(date[0])
                    }}
                    options={{ inline: true, defaultDate: date }}
                  />
                  {
                    this.state.chooseHour ?
                      <div className="time-content-hour">
                        <div className="close-choose-time" onClick={() => this.chooseHour(false)}>
                          <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                        </div>
                        <div>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '01')}><button className="nav-link">01</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '02')}><button className="nav-link">02</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '03')}><button className="nav-link">03</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '04')}><button className="nav-link">04</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '05')}><button className="nav-link">05</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '06')}><button className="nav-link">06</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '07')}><button className="nav-link">07</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '08')}><button className="nav-link">08</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '09')}><button className="nav-link">09</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '10')}><button className="nav-link">10</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '11')}><button className="nav-link">11</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '12')}><button className="nav-link">12</button></li>
                          </ul>
                        </div>
                      </div>
                      :
                      ''
                  }
                  {
                    this.state.chooseMinute ?
                      <div className="time-content-minute">
                        <div className="close-choose-time" onClick={() => this.chooseMinute(false)}>
                          <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                        </div>
                        <div>
                          <ul>
                            <li className={''} onClick={(e) => this.selectMinute(e, '00')}><button className="nav-link">00</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '05')}><button className="nav-link">05</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '10')}><button className="nav-link">10</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '15')}><button className="nav-link">15</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectMinute(e, '20')}><button className="nav-link">20</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '25')}><button className="nav-link">25</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '30')}><button className="nav-link">30</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '35')}><button className="nav-link">35</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectMinute(e, '40')}><button className="nav-link">40</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '45')}><button className="nav-link">45</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '50')}><button className="nav-link">50</button></li>
                            <li className={''} onClick={(e) => this.selectMinute(e, '55')}><button className="nav-link">55</button></li>
                          </ul>
                        </div>
                      </div>
                      :
                      ''
                  }
                </div>
                <div className="mt-3 col-12 text-center">
                  <div>
                    <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.reScheduleModal(true, "yes")}>
                      {this.state.pleaseWait ? "Rescheduling..." : "Reschedule Appointment"}
                    </RBT.Button>
                  </div>
                </div>
              </div>
            </RBT.Modal.Body>
          </RBT.Modal>
          {/* End reschedule modal */}

          {/* Start Event Detail modal */}
          <RBT.Modal className="eventDetail" size="md" centered show={this.state.eventDetailModalShow} onHide={() => this.eventDetailModalClose(false)} >
            <RBT.Modal.Header closeButton>
              <RBT.Modal.Title>Event Details</RBT.Modal.Title>
            </RBT.Modal.Header>
            <RBT.Modal.Body>
              <div className="add-schedule">
                <div className="add-schedule-modal-btwn">
                  <div className="row">
                    <div className="col-6">
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faUser} /> {this.state.contact_name}
                        <span>{this.state.promo_name}</span>
                      </div>
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faBriefcase} /> {this.state.owner_name}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faCalendarCheck} className="text-success" />
                        {this.state.event_date}
                      </div>
                      <div className="add-schedule-modal-btwn-text">
                        <FontAwesomeIcon icon={faIcon.faClock} />
                        {this.state.event_time}
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
                <div className="row">
                  <div className="col-12 text-center">
                    <button className="btn btn-danger btn-sm" onClick={() => this.cancelScheduleModal(true, "no")}>Cancel</button>
                    <button className="btn btn-primary ml-1 btn-sm" onClick={() => this.reScheduleModal(true, "no")} >Reschedule</button>
                  </div>
                </div>
              </div>
            </RBT.Modal.Body>
          </RBT.Modal>
          {/* End Event Detail modal */}

          {/*--Start Reschedule Message Time Modal --*/}
          <RBT.Modal className="live-chat-modal calender-and-clock-modal re-schedule-message-time-modal only-add" size="md" centered show={this.state.ReScheduleMsgTimeModalShow} onHide={() => this.reScheduleMessageTimeModal(false)} >
            <RBT.Modal.Header closeButton>
              <RBT.Modal.Title>Reschedule Message Time</RBT.Modal.Title>
            </RBT.Modal.Header>
            <RBT.Modal.Body>
              <div className="re-schedule">
                {
                  this.state.errorReScheduleMsg ?
                    <AlertWrapper errors_data={this.state.errorReScheduleMsg} isFormValid="" /> : ""
                }
                <div className="alert-message-wrapper">
                  <AlertWrapperSuccess errors_data={this.state.successReScheduleMsg} success_alert_wrapper_show={this.state.success_alert_wrapper_show} />
                </div>
                {
                  this.state.scheduleMessageTimeLoading ?
                    <div className="loading mh-400">
                      <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                    </div>
                    :
                    <Fragment>
                      <div className="">
                        <div className="conversationReleaseAlert-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faUser} />{" "}
                          {this.state.schedule_contact_name} <span className="modal-btwn-text">{this.state.schedule_promo_name}</span>
                        </div>
                        <div className="conversationReleaseAlert-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faBriefcase} />{" "}
                          {this.state.schedule_user_name}
                        </div>
                        <div className="conversationReleaseAlert-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faEnvelope} />{" "}
                          Message Text: <span className="border-left-0 m-0 p-0 messageTextscheduleMessage" dangerouslySetInnerHTML={{ __html: this.state.schedule_message_text }}></span>
                        </div>
                        <hr />
                      </div>

                      <div className="row flatpickerDiv">
                        <div className="">
                          <Flatpickr
                            data-enable-time
                            onChange={(date) => {
                              this.setScheduleDateTime(date[0], "message")
                            }}
                            options={{ inline: true, minuteIncrement: 1, defaultDate: moment(this.state.schedule_date + ' ' + this.state.schedule_time).format("YYYY-MM-DD HH:mm:ss") }}
                          />
                          {
                            this.state.chooseHour ?
                              <div className="time-content-hour">
                                <div className="close-choose-time" onClick={() => this.chooseHour(false)}>
                                  <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                                </div>
                                <div>
                                  <ul>
                                    <li className={''} onClick={(e) => this.selectHour(e, '01')}><button className="nav-link">01</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '02')}><button className="nav-link">02</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '03')}><button className="nav-link">03</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '04')}><button className="nav-link">04</button></li>
                                  </ul>
                                  <ul>
                                    <li className={''} onClick={(e) => this.selectHour(e, '05')}><button className="nav-link">05</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '06')}><button className="nav-link">06</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '07')}><button className="nav-link">07</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '08')}><button className="nav-link">08</button></li>
                                  </ul>
                                  <ul>
                                    <li className={''} onClick={(e) => this.selectHour(e, '09')}><button className="nav-link">09</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '10')}><button className="nav-link">10</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '11')}><button className="nav-link">11</button></li>
                                    <li className={''} onClick={(e) => this.selectHour(e, '12')}><button className="nav-link">12</button></li>
                                  </ul>
                                </div>
                              </div>
                              :
                              ''
                          }
                          {
                            this.state.chooseMinute ?
                              <div className="time-content-minute">
                                <div className="close-choose-time" onClick={() => this.chooseMinute(false)}>
                                  <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                                </div>
                                <div>
                                  <ul>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '00')}><button className="nav-link">00</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '05')}><button className="nav-link">05</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '10')}><button className="nav-link">10</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '15')}><button className="nav-link">15</button></li>
                                  </ul>
                                  <ul>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '20')}><button className="nav-link">20</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '25')}><button className="nav-link">25</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '30')}><button className="nav-link">30</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '35')}><button className="nav-link">35</button></li>
                                  </ul>
                                  <ul>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '40')}><button className="nav-link">40</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '45')}><button className="nav-link">45</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '50')}><button className="nav-link">50</button></li>
                                    <li className={''} onClick={(e) => this.selectMinute(e, '55')}><button className="nav-link">55</button></li>
                                  </ul>
                                </div>
                              </div>
                              :
                              ''
                          }
                        </div>
                      </div>
                      <div className="mt-3 col-12 text-center">
                        <RBT.Button
                          disabled={this.state.pleaseWaitRescheduleTime}
                          onClick={() => this.reScheduleMessageTimeModal(true, "yes")}
                        >
                          {this.state.pleaseWaitRescheduleTime ? "Rescheduling..." : "Reschedule"}
                        </RBT.Button>
                      </div>
                    </Fragment>

                }

              </div>
            </RBT.Modal.Body>
          </RBT.Modal>
          {/*--End Reschedule Message Time Modal --*/}

          {/* Start Calcel Schedule modal */}
          <RBT.Modal
            className="live-chat-modal"
            centered
            show={this.state.cancelScheduleModalShow}
            onHide={() => this.cancelScheduleModal(false)}
          >
            <RBT.Modal.Header closeButton>
              <RBT.Modal.Title>Cancel Schedule</RBT.Modal.Title>
            </RBT.Modal.Header>
            <RBT.Modal.Body>
              <div className="delete-content">
                <div>
                  {this.state.errorCancelScheduleMsg ? (
                    <div className="text-center text-danger">{this.state.errorCancelScheduleMsg}</div>
                  ) : (
                    Parser(`<span>Are you sure,</span> you want to Cancel this Appointment?`)
                  )}
                  <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.cancelScheduleModal(true, "yes")}>
                    {this.state.pleaseWait ? "Cancelling..." : "Yes"}
                  </RBT.Button>
                </div>
              </div>
            </RBT.Modal.Body>
          </RBT.Modal>
          {/* End Calcel Schedule modal */}

          {/*--Start Edit Reschedule Message Modal --*/}
          <RBT.Modal className="live-chat-modal rescheduleModal edit-reschedule-message-modal-right" size="lg" centered show={this.state.EditReScheduleMsgModalShow} onHide={() => this.editReScheduleMessageModal(false)} >
            <RBT.Modal.Header closeButton>
              <RBT.Modal.Title>Edit Scheduled Message</RBT.Modal.Title>
            </RBT.Modal.Header>
            <RBT.Modal.Body>
              {
                this.state.scheduleMessageEditLoading ?
                  <div className="loading mh-310">
                    <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                  </div>
                  :
                  <div className="rescheduleModal-container ">
                    <Fragment>
                      <div className="rescheduleModal-left">

                        {
                          this.state.errorEditScheduleMsg ?
                            <AlertWrapper errors_data={this.state.errorEditScheduleMsg} isFormValid="" /> : ""
                        }

                        <div className="alert-message-wrapper">
                          <AlertWrapperSuccess errors_data={this.state.successEditScheduleMsg} success_alert_wrapper_show={this.state.success_alert_wrapper_show} />
                        </div>

                        <Fragment>
                          <div className="rescheduleModal-left-date">
                            <div className="conversationReleaseAlert-btwn">
                              <div className="conversationReleaseAlert-btwn-text">
                                <FontAwesomeIcon icon={faIcon.faUser} />{" "}
                                {this.state.schedule_contact_name} <span className="modal-btwn-text">{this.state.schedule_promo_name}</span>
                              </div>
                              <div className="conversationReleaseAlert-btwn-text">
                                <FontAwesomeIcon icon={faIcon.faBriefcase} />{" "}
                                {this.state.schedule_user_name}
                              </div>
                            </div>
                            <div className="conversationReleaseAlert-btwn-date">
                              <FontAwesomeIcon icon={faIcon.faCalendarCheck} /> {moment(this.state.schedule_date).format("MMM DD")}, {this.state.schedule_time}
                            </div>
                          </div>
                          <div className="rescheduleModal-left-sms-save-opt">
                            <div className="conversationReleaseAlert-btwn-text">
                              <FontAwesomeIcon icon={faIcon.faEnvelopeOpen} />{" "}
                              Message text
                            </div>
                            <textarea
                              cols="50"
                              rows="4"
                              id="edit_schedule_message"
                              className="form-control"
                              name="schedule_message_text"
                              onKeyUp={this.typeMessage}
                            ></textarea>
                            <div className="rescheduleModal-left-sms-save-btn">
                              <RBT.Button
                                disabled={this.state.pleaseWaitEditSchedule}
                                onClick={() => this.editReScheduleMessageModal(true, "yes")}
                              >
                                {this.state.pleaseWaitEditSchedule ? "Wait..." : "Save"}
                              </RBT.Button>
                            </div>
                          </div>

                        </Fragment>

                      </div> {/*--end left --*/}

                      <div className="rescheduleModal-right">
                        <div className="live-chat-short-code">
                          <div className="live-chat-short-code-header">
                            <div className="title">
                              Shortcodes
                              <span className={this.state.activeShortcode === 'default' ? 'active' : 'tab-style'}
                                onClick={() => this.handleShortcode('default')}
                              >
                                Most Used
                              </span>
                              <span
                                className={this.state.activeShortcode !== 'default' ? 'active' : 'tab-style'}
                                onClick={() => this.handleShortcode('all_shortcode')}
                              >All </span>
                            </div>
                            <RBT.Form className="live-chat-short-code-search">
                              <RBT.Form.Control
                                type="text"
                                placeholder="Search"
                                onChange={(e) => this.codeSearch(e)}
                                name="code_search"
                                value={this.state.code_search}
                              />
                            </RBT.Form>
                          </div>

                          <div className="live-chat-short-code-tag">

                            {this.state.activeShortcode === "default" ? (
                              <div className="live-chat-short-code-tag">
                                {this.state.mostUsedShortcodeLoading ? (
                                  <div className="loading">
                                    <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                                  </div>
                                ) : (
                                  <Fragment>
                                    {this.state.mostUsedShortCodeList.length <= 0 ? (
                                      <div className="server-error-message">
                                        {Parser(this.state.errorMostUsedShortCodeMessage)}
                                      </div>
                                    ) : (
                                      <Scrollbars
                                        renderTrackVertical={(props) => (
                                          <div {...props} className="track-vertical" />
                                        )}
                                        renderThumbVertical={(props) => (
                                          <div {...props} className="thumb-vertical" />
                                        )}
                                        className="customer-sms-list-scrollbars"
                                        style={{ height: 200 }}
                                      >

                                        <span className="shortcode-section">
                                          <span className="shortcode-section-data shortcode-flex-wrap">
                                            {
                                              this.state.mostUsedShortCodeList.map((shortCode, key) => {
                                                if (
                                                  this.state.code_search === "" ||
                                                  shortCode.field_name
                                                    .toUpperCase()
                                                    .includes(
                                                      this.state.code_search.toUpperCase()
                                                    )
                                                )
                                                  return (
                                                    <Fragment key={"mshkparentsc" + key}>
                                                      {
                                                        (shortCode.window_key !== '') && (shortCode.mac_key !== '') ?
                                                          <Hotkeys
                                                            keyName={`${shortCode.window_key},${shortCode.mac_key}`}
                                                            onKeyDown={this.onKeyDown.bind(this)}
                                                            filter={(event) => {
                                                              return true;
                                                            }}
                                                          ></Hotkeys>
                                                          : ''
                                                      }

                                                      <RBT.OverlayTrigger
                                                        key={shortCode.id}
                                                        placement={"bottom"}
                                                        overlay={
                                                          <Tooltip>
                                                            {shortCode.field_value} (Hotkey: {(shortCode.window_key !== '') && (shortCode.mac_key !== '') ? shortCode.window_key + ' or ' + shortCode.mac_key : 'not assigned'})
                                                          </Tooltip>
                                                        }
                                                      >

                                                        <button
                                                          id={ismac ? 'sma' + shortCode.mac_key : 'sma' + shortCode.window_key}
                                                          className={`nav-link ${shortCode.window_key} ${shortCode.mac_key}`}
                                                          onClick={(e) =>
                                                            this.addShortcode(e, shortCode)
                                                          }
                                                        >
                                                          [{shortCode.field_name}]
                                                        </button>
                                                      </RBT.OverlayTrigger>

                                                    </Fragment>

                                                  );
                                                return true;
                                              })
                                            }
                                          </span>
                                        </span>

                                      </Scrollbars>
                                    )}
                                  </Fragment>
                                )}
                              </div>
                            ) : (
                              <div className="live-chat-short-code-tag">
                                {this.state.shortCodeLoading ? (
                                  <div className="loading">
                                    <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                                  </div>
                                ) : (
                                  <Fragment>
                                    {this.state.shortCodeList.length <= 0 ? (
                                      <div className="server-error-message">
                                        {Parser(this.state.errorShortCodeMessage)}
                                      </div>
                                    ) : (
                                      <Scrollbars
                                        renderTrackVertical={(props) => (
                                          <div {...props} className="track-vertical" />
                                        )}
                                        renderThumbVertical={(props) => (
                                          <div {...props} className="thumb-vertical" />
                                        )}
                                        className="customer-sms-list-scrollbars"
                                        style={{ height: 200 }}
                                      >
                                        {this.state.shortCodeList.map((shortCode_single, key) => {
                                          return (
                                            <span className="shortcode-section">
                                              <span className="shortcode-section-title">
                                                {shortCode_single.campaign_name}
                                              </span>
                                              {shortCode_single.fields.length > 0 ? (
                                                <span className="shortcode-section-data shortcode-flex-wrap">
                                                  {shortCode_single.fields.map((shortCode, key) => {
                                                    if (
                                                      this.state.code_search === "" ||
                                                      shortCode.field_name
                                                        .toUpperCase()
                                                        .includes(
                                                          this.state.code_search.toUpperCase()
                                                        )
                                                    )
                                                      return (
                                                        <Fragment>
                                                          {
                                                            (shortCode.window_key !== '') && (shortCode.mac_key !== '') ?
                                                              <Hotkeys
                                                                keyName={`${shortCode.window_key},${shortCode.mac_key}`}
                                                                onKeyDown={this.onKeyDown.bind(this)}
                                                                filter={(event) => {
                                                                  return true;
                                                                }}
                                                              ></Hotkeys>
                                                              : ''
                                                          }

                                                          <RBT.OverlayTrigger
                                                            key={shortCode.id}
                                                            placement={"bottom"}
                                                            overlay={
                                                              <Tooltip>
                                                                {shortCode.field_value} (Hotkey: {(shortCode.window_key !== '') && (shortCode.mac_key !== '') ? shortCode.window_key + ' or ' + shortCode.mac_key : 'not assigned'})
                                                              </Tooltip>
                                                            }
                                                          >
                                                            <button
                                                              id={ismac ? 'sma' + shortCode.mac_key : 'sma' + shortCode.window_key}
                                                              className={`nav-link ${shortCode.window_key} ${shortCode.mac_key}`}
                                                              onClick={(e) =>
                                                                this.addShortcode(e, shortCode)
                                                              }
                                                            >
                                                              [{shortCode.field_name}]
                                                            </button>
                                                          </RBT.OverlayTrigger>
                                                        </Fragment>

                                                      );
                                                    return true;
                                                  })}
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          );
                                        })}
                                      </Scrollbars>
                                    )}
                                  </Fragment>
                                )}
                              </div>
                            )}

                          </div>{/*--- end live-chat-short-code-tag --*/}

                        </div>
                      </div> {/*-- end right --*/}

                    </Fragment>

                  </div>
              }
            </RBT.Modal.Body>
          </RBT.Modal>
          {/*--End Edit Rechedule Message Modal --*/}

        </Fragment>
    );
  }
}

export default ScheduleMessageArea;